import fetchData from "../API/Fetch";
import { store } from "../store";

export default async function fetchDeviceTypes() {
  let result = await fetchData(`/device-types/`);

  store.dispatch({
    type: "deviceTypes/update",
    payload: result ? result : [],
  });
  return result;
}
